var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('ShouyeTop')],1),_c('div',[_c('Chart')],1),_c('div',[_c('shouyeBottom')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }